import { render, staticRenderFns } from "./WidgetSettingsLayout.vue?vue&type=template&id=1a9f74f7&scoped=true"
import script from "./WidgetSettingsLayout.vue?vue&type=script&lang=js"
export * from "./WidgetSettingsLayout.vue?vue&type=script&lang=js"
import style0 from "./WidgetSettingsLayout.vue?vue&type=style&index=0&id=1a9f74f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9f74f7",
  null
  
)

export default component.exports